var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoadingLine',{attrs:{"title":"File ảnh đang được cập nhật","count":_vm.taskProgress.progress}})}
var staticRenderFns = []

export { render, staticRenderFns }